const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#005f5a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.98,9.35l-1.97,1.93s2.34,2.53,6.02,2.53,5.98-2.44,5.98-2.44l-2.02-1.97s-1.3,1.59-3.95,1.59-4.05-1.64-4.05-1.64Z",
    style: {
      fill: "#f0643c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.49,7.69c.12.37.12.76,0,1.12-.12.36-.35.67-.66.89-.31.22-.69.33-1.07.32h-2.95v-5.83h2.64c.44,0,.87.18,1.18.49.31.31.49.74.49,1.18,0,.33-.11.66-.29.93.31.22.55.53.66.89h0ZM7.97,6.45h1.48c.16,0,.31-.06.43-.17.12-.11.18-.26.19-.42,0-.09-.02-.16-.05-.24-.04-.07-.08-.14-.14-.2-.06-.05-.13-.1-.2-.13-.08-.03-.16-.04-.23-.04h-1.48v1.2ZM10.06,8.91c.1-.04.18-.08.26-.15.07-.07.13-.15.17-.24.04-.09.06-.19.06-.29s-.02-.2-.06-.29c-.04-.09-.1-.17-.17-.24-.08-.07-.16-.12-.26-.15-.09-.03-.19-.05-.29-.04h-1.8v1.44h1.8c.1.01.2,0,.29-.04Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancor);
export default __webpack_public_path__ + "static/media/bancor.abbf24f3fdedc098c7928e2a5bb1f7e5.svg";
export { ForwardRef as ReactComponent };